import React, { PureComponent } from 'react';
import styles from './index.css';
const { callApp } = require('@ifeng-fe/callapp');
import { WxLaunchHack } from '../../../../wxLaunchHack';
/**
 * 提示：试看五分钟
 */
class ShortTips extends PureComponent {
    constructor() {
        super(...arguments);
        this.spanHandleCalledApp = () => {
            const { callAppConfig } = this.props;
            callApp(callAppConfig);
        };
    }
    render() {
        const { mobileClosureTime, callAppConfig } = this.props;
        const wxLaunchHackData = {
            callAppConfig: callAppConfig,
        };
        return (React.createElement("div", { className: styles.shortTips },
            "\u53EF\u8BD5\u770B",
            mobileClosureTime,
            "\u79D2\uFF0C\u53BB",
            ' ',
            React.createElement("span", { className: styles.fhxwkhd },
                "\u51E4\u51F0\u7F51\u65B0\u95FB\u5BA2\u6237\u7AEF",
                React.createElement(WxLaunchHack, { content: wxLaunchHackData })),
            ' ',
            "\u89C2\u770B"));
    }
}
export default ShortTips;
